import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getSong } from "../../lib/api";
import { ArrowLeft } from "lucide-react";

const LYRICS = {
  "bring-it-on": `[Verse 1]\nYeah Father God, you sent your son,\nLet me know it's time to bring it on,\nDemon's returned that once we're gone,\nHad me tapping out in round one,\n\n[Pre Chorus]\nThen I remembered The cross, his word, his blood,\nShouted out his name, lifted me from the mud,\nThe Foster System that once broke me, made me a diamond stud,\nStruck down the devil's Cruise Missile, made it nothin but a dud,\n\n[Chorus]\nBring it on, time we rise,\nGod's super size, No more last Prize,\nSeeing through the Devil's disguise and those Big bang lies,\nYeah HIS Son Loves Thundering skies,\n\n[Outro]\nGods kingdom come,\nHe brings it on,\nThis Foster Kid is Chosen,\nBring it on,\nSinging The Angel's Victory SONG!`,
  "philly-foster-kid": `[Verse 1]\nOnce upon a time, I had a normal life,\nThen the Devil flipped the script, "boom", nuthin but strife,\nSimple life and times just vanished in a blink,\nStruggled, like skating on an unfrozen Hockey Rink,\nJust numbers in the system, Philly Foster Kids lost,\nThrown out, abandoned, pieces of garbage tossed,\nTwenty Two Hundred of my fellow homies, waiting for their forever home,\nNot invisible or forgotten, man Jesus bringing y'all Home!\n\n[Chorus]\nFelt the rush of his living water,\nFelt the love for his sons and daughters,\nHe reorders the pecking order,\nThis Philly Foster Kid is Now setup in Heavens Quarters`,
  "holy-ghost": `[Pre Chorus]\nJesus said, 'I gotta roll' but I'll leave you The Helper,\n'Ask anything in my name', Advocate, Our Inter Dweller,\nHoly Ghost is beyond stellar, Spirit of Christ, Our Great Helper,\nBaptism of the Spirit thru water and fire, (Holy Ghost) our intercessor\n\n[Chorus]\nHoly Ghost, heal the orphan child,\nTake the broken, make them reconciled,\nHoly Ghost, Great Comforter to the lost,\nBrings Spiritual Gifts, protects our Temple at all cost,\nHoly Ghost, Our Counsellor, Sanctifier, Spirit Guider—\nFor every foster heart make a home, ignite their Fire!`,
  "lost-then-found": `[Chorus]\nYeah, We were Lost then we got Found,\nJesus was our anchor when the storms went down,\nFather GOD rebuilt what the devil tore down,\nThru his Word and The Holy Spirit, The Lost get found,\n\n[Verse 2]\nCaseworkers bailing, Orphans flailing,\nNever prevailing, System just failing,\nWe should be fighting, But we've been stomped and beaten,\nNow we're crying out for a miracle, Lord we're drowning!`,
  "all-you-gotta-do-is-believe": `[Verse 1]\nMy Foster Past full of pain and rebellion, should have juked,\nEventually Got in the Lord's word, familiar spirits rebuked,\nDemons roared inside my body temple, fled as I puked,\nDropped the Holy Spirit scud bomb, yeah the Devil got nuked,\n\n[Bridge]\nHalf a million orphans had nowhere to run,\nHalf a Million hopeless Gazes at the sun,\nWe fired prayers for them like a Holy Spirit Gatling gun,\nSent Half a Million Praises up to the real son,\nLord Turned our darkest Foster days into laughter, joy and fun,\nHalf a million Kids protected, Got Love and Families, The Son has WON!`,
  "misunderstood": `[Verse 1]\nThe moments You think that I care, I probably don't,\nAnd just when You think that I may, I probably won't,\nWeird when I flash a smile, you see nothing but a frown,\nNo discernment of when I'm happy or actually down?\n\nWe happened under my watch and I'm responsible,\nPushed people away in the pain when I was hiding from the horrible,\nThe Moments of my life, The Pain, Shame, Passing the Blame,\nAlways Feeling Lame, dreams down the drain, No Family, lost my Name`,
};

export default function SongDetail() {
  const { slug } = useParams();
  const [song, setSong] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    getSong(slug).then(setSong).catch(() => setErr("Track not found"));
  }, [slug]);

  if (err) return (
    <div className="container-xl py-32 text-center" data-testid="song-not-found">
      <h2 className="font-display text-5xl">{err}</h2>
      <Link to="/anthem/catalog" className="btn-outline mt-8 inline-flex">Back to Catalog</Link>
    </div>
  );
  if (!song) return <div className="container-xl py-32 font-mono text-an-muted" data-testid="song-loading">Loading…</div>;

  const lyrics = song.lyrics || LYRICS[slug];
  const baseSlug = slug.replace(/-anthem$/, "");

  return (
    <div data-testid="song-detail-page">
      <section className="border-b border-an-border">
        <div className="container-xl pt-20 pb-14">
          <Link to="/anthem/catalog" className="overline link-ul flex items-center gap-2 mb-8 text-an-muted" data-testid="song-back">
            <ArrowLeft size={14} /> Back to Catalog
          </Link>
          <div className="grid md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <div className="aspect-square border border-an-border overflow-hidden">
                <img src={song.image || "https://customer-assets.emergentagent.com/job_redemption-songs/artifacts/u1pk93uo_FosterCareAnthem_VOL1_Cover.png"} alt={song.title} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="md:col-span-7">
              <div className="overline text-an-gold mb-3">Track № {String(song.number).padStart(2,"0")} · {song.mood}</div>
              <h1 className="font-display text-5xl md:text-7xl leading-[0.95]">{song.title}</h1>
              <blockquote className="mt-6 font-display italic text-2xl text-an-muted">"{song.tagline}"</blockquote>
              <div className="mt-8 grid grid-cols-3 gap-4 border-y border-an-border py-4">
                <div><div className="overline text-an-muted">BPM</div><div className="font-mono text-lg mt-1">{song.bpm || "—"}</div></div>
                <div><div className="overline text-an-muted">Key</div><div className="font-mono text-lg mt-1">{song.key || "—"}</div></div>
                <div><div className="overline text-an-muted">Album</div><div className="font-mono text-xs mt-1">{song.album}</div></div>
              </div>
              <div className="mt-8 flex flex-wrap gap-3">
                <a href="https://open.spotify.com/album/26KvumSBMwlSTWFNpTvqJl" target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="song-spotify">Listen on Spotify</a>
                {song.youtube && <a href={song.youtube} target="_blank" rel="noopener noreferrer" className="btn-outline" data-testid="song-youtube">Watch on YouTube</a>}
                <Link to="/anthem/licensing" className="btn-outline" data-testid="song-license">License this Track</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {song.description && (
        <section className="border-b border-an-border">
          <div className="container-xl py-16 max-w-3xl">
            <div className="overline text-an-gold mb-4">About the Track</div>
            <p className="text-lg leading-relaxed text-an-muted">{song.description}</p>
          </div>
        </section>
      )}

      {song.favorite_verse && (
        <section className="border-b border-an-border bg-an-surface">
          <div className="container-xl py-16 max-w-4xl">
            <div className="overline text-an-gold mb-4">Favorite Verse</div>
            <blockquote className="font-display text-3xl md:text-5xl italic leading-tight">"{song.favorite_verse}"</blockquote>
          </div>
        </section>
      )}

      {song.artist_note && (
        <section className="border-b border-an-border">
          <div className="container-xl py-16 max-w-3xl">
            <div className="overline text-an-gold mb-4">From the Producer</div>
            <p className="whitespace-pre-line text-base leading-relaxed text-an-muted">{song.artist_note}</p>
          </div>
        </section>
      )}

      {lyrics && (
        <section>
          <div className="container-xl py-20 max-w-3xl">
            <div className="overline text-an-gold mb-4">Lyrics</div>
            <h2 className="font-display text-3xl mb-8">{song.title.replace(" (Anthem Edition)","")}</h2>
            <pre className="whitespace-pre-wrap font-sans text-base leading-[1.9] text-an-ink" data-testid="song-lyrics">{lyrics}</pre>
            <div className="mt-10 pt-6 border-t border-an-border text-xs text-an-muted font-mono">
              Lyrics © Timothy P. Kelly · Foster Care Anthem Project. Used with permission.
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
